<template>
    <div class="head">
        <div class="left-timer">{{ timer }}</div>
        <div class="head-title">
            <img src="../../assets/j-logo.png" alt="" class="j-logo" v-if="+rolelevel < 2 && !isFirst">
            {{ title }}
        </div>
        <div class="large" @click="screen">
            <img src="@/assets/temimg2/screen.png" alt="">
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'

export default {
    name: 'headtitle.temhead5',
    props: {
        title: {
            type: String,
            default: '涉罪未成年人情况分析大屏'
        },
        rolelevel: {
            type: [String, Number],
            default: -1
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timer: ''
        }
    },
    mounted() {
        this.gettime()
    },
    methods: {
        gettime() {
            this.timer = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        screen () {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
            // this.$message("您的浏览器不能全屏")
            return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 124px;
    background: url(@/assets/temimg5/head.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 401;
    pointer-events: none;
    .head-title {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 50px;
        line-height: 37px;
        color: #FFFFFF;
        text-shadow: 0px 10px 10px rgba(255, 255, 255, 0.69);
        height: fit-content;
        padding: 8px;
        margin-top: -40px;
        position: relative;
    }
    .j-logo {
        position: absolute;
        width: 60px;
        height: 36px;
        left: -60px;
    }
    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 40px;
        text-shadow: 0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8);
    }
    .large {
        position: absolute;
        right: 64px;
        top: 25px;
        cursor: pointer;
        pointer-events: auto;
        img {
            width: 46px;
            height: 46px;
        }
    }
}
</style>